import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'product-info',
  name: '商品信息',
  icon: '价',
  group: '商品详情页',
  description: '价格、标题、卖点、销量和规格摘要',
  defaultProps: {
    showMarketPrice: true,
    showSales: true,
    showStock: true
  }
}
